import PortalIdParser from 'PortalIdParser';
export const APP_BASE = `/calling-cross-tab-embed`;
export const SHARED_WORKER_URL = `${APP_BASE}/shared-worker.js`;
export const getRootUrl = () => `${APP_BASE}/${PortalIdParser.get()}`;